// extracted by mini-css-extract-plugin
export default {"menuWrapper":"PageMenu_menuWrapper__MH2bh","userWrapper":"PageMenu_userWrapper__yqvcO"};